import { render, staticRenderFns } from "./VehicleCost.vue?vue&type=template&id=53cfca42&scoped=true&"
import script from "./VehicleCost.vue?vue&type=script&lang=js&"
export * from "./VehicleCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cfca42",
  null
  
)

export default component.exports